import React from 'react';
import {Form, Formik, FormikHelpers} from "formik";
import Label from "components/Form/Label";
import Field from "components/Form/Field";
import * as Yup from "yup";
import {ErrorNotification} from "../../../components/Form/ErrorNotification";
import Button from "../../../components/Button";

// Types ----

export type ConfirmCodeData = {
  code: string
}

type ConfirmCodeFormProps = {
  onCancel: () => void
  onSubmit: (values: ConfirmCodeData, helpers: FormikHelpers<ConfirmCodeData>) => any
}

// Context ----

function ConfirmCodeForm({onCancel, onSubmit}: ConfirmCodeFormProps) {
  const validationSchema = Yup.object().shape({
    code: Yup.string()
      .matches(/\d{6}/, 'Must be 6 digits.')
      .required('A verification code is required.'),
  })

  const initialValues: ConfirmCodeData = {
    code: '',
  }

  return (
    <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
      {formik => {
        return (
          <Form>
            <ErrorNotification formik={formik} />
              <div>
                <p className="mt-1 text-sm text-gray-500">
                  Enter the six-digit code displayed in your authenticator app. This code will typically refresh every 30 seconds.
                </p>

                <div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                  <div className="sm:col-span-3 sm:col-start-1">
                    <Label htmlFor="password">Code *</Label>
                    <div className="mt-1">
                      <Field
                        type="text"
                        name="code"
                        id="code"
                        autoComplete="off"
                        maxLength="6"
                        autoFocus
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className='flex gap-4 mt-8'>
                <Button
                  type='submit'
                  color={Button.colors.PRIMARY}
                  disabled={formik.isSubmitting}
                  showSpinner={formik.isSubmitting}
                >
                  Confirm code and continue
                </Button>

                <Button
                  type='button'
                  color={Button.colors.WHITE}
                  onClick={onCancel}
                  disabled={formik.isSubmitting}
                >
                  Back
                </Button>
              </div>
          </Form>
        )
      }}
    </Formik>
  );
}

export {ConfirmCodeForm};